(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["df-sticky-atc"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('df-sticky-cart')) {
    customElements.define('df-sticky-cart', class extends HTMLElement {
      connectedCallback() {
        this.proxy = this.querySelector('.df-sticky-atc__btn');
        this.price = this.querySelector('.df-sticky-atc__price');
        this.titleElement = this.querySelector('.df-sticky-atc__title');
        this.onLoaded = this.bindProduct.bind(this);
        this.onClick = () => {
          this.sync();
          if (!this.target || this.proxy.disabled) return;
          this.target.click();
        };
        this.proxy.addEventListener('click', this.onClick);
        document.addEventListener('product-info:loaded', this.onLoaded);
        window.addEventListener('pageshow', this.onLoaded);
        this.bindProduct();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.visibilityObserver?.disconnect();
        this.proxy.removeEventListener('click', this.onClick);
        document.removeEventListener('product-info:loaded', this.onLoaded);
        window.removeEventListener('pageshow', this.onLoaded);
      }

      bindProduct() {
        this.observer?.disconnect();
        this.visibilityObserver?.disconnect();
        this.productRoot = document.querySelector('product-info[id^="MainProduct-"]');
        this.target = this.productRoot?.querySelector('button[name="add"][id^="ProductSubmitButton-"]');
        this.hidden = true;
        if (!this.target || !('IntersectionObserver' in window)) return;

        this.observer = new MutationObserver(() => this.sync());
        this.observer.observe(this.productRoot, {
          subtree: true,
          childList: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled']
        });
        this.visibilityObserver = new IntersectionObserver((entries) => {
          const entry = entries[0];
          const visible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.hidden = !visible;
          this.classList.toggle('is-visible', visible);
        });
        this.visibilityObserver.observe(this.target);
        this.sync();
      }

      sync() {
        this.target = this.productRoot?.querySelector('button[name="add"][id^="ProductSubmitButton-"]');
        if (!this.target) {
          this.hidden = true;
          this.proxy.disabled = true;
          return;
        }
        this.proxy.disabled = this.target.disabled || this.target.getAttribute('aria-disabled') === 'true';
        const label = Array.from(this.target.children).find((child) => child.tagName === 'SPAN' && !child.classList.contains('hidden'));
        if (label?.textContent.trim()) this.proxy.textContent = label.textContent.trim();
        const priceRoot = this.productRoot.querySelector('.mainp-price');
        const priceContainer = priceRoot?.querySelector('.price__container');
        const selector = priceContainer?.classList.contains('price--on-sale')
          ? '.price__sale .price-item--sale'
          : '.price__regular .price-item--regular:last-child';
        const sourcePrice = priceRoot?.querySelector(selector);
        this.price.hidden = !sourcePrice || priceRoot.classList.contains('hidden');
        if (sourcePrice) this.price.textContent = sourcePrice.textContent.trim();
        const productTitle = this.productRoot.querySelector('h1');
        if (productTitle) this.titleElement.textContent = productTitle.textContent.trim();
        const hasPopup = this.target.getAttribute('aria-haspopup');
        if (hasPopup) this.proxy.setAttribute('aria-haspopup', hasPopup);
        else this.proxy.removeAttribute('aria-haspopup');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
